// extracted by mini-css-extract-plugin
export var article = "product-module--article--zxPCI";
export var description = "product-module--description--+4J+c";
export var description2 = "product-module--description2--1OQyb";
export var title = "product-module--title--555YT";
export var title2 = "product-module--title2--dE9NF";